import { useEffect } from 'react';

/**
 * Lightweight SEO component without external dependencies.
 * Sets document title and meta tags directly. Cleans up nothing on unmount —
 * the next page will overwrite these values, which is the desired SPA behavior.
 */
const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [_, key, val] = selector.match(/\[(\w+)="([^"]+)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const SEOHead = ({
  title = 'EduLab Monitor — Hands-on Learning for Every Classroom',
  description = 'Track lab activities, monitor school performance, and empower teachers across India with EduLab Monitor — a multi-state lab usage platform.',
  keywords = 'lab monitoring, school dashboard, education platform, lab activity tracking, government schools, teacher dashboard, India education',
  image = '/og-image.png',
  url,
  type = 'website',
}) => {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="keywords"]', 'content', keywords);
    setMeta('meta[name="theme-color"]', 'content', '#4f46e5');
    setMeta('meta[name="robots"]', 'content', 'index, follow');

    // Open Graph
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:type"]', 'content', type);
    setMeta('meta[property="og:image"]', 'content', image);
    if (url) setMeta('meta[property="og:url"]', 'content', url);

    // Twitter
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);

    // Canonical
    if (url) setLink('canonical', url);
  }, [title, description, keywords, image, url, type]);

  return null;
};

export default SEOHead;
